import React from "react";

import _ from "lodash";
import styled from "styled-components";

import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const TextToPresent = styled.div`
    text-overflow: ellipsis;
    overflow: hidden;
`;

/**
 @deprecated
 instead, use TooltipTextAnchorCell from pro-logic-components
 **/
export const TextWithTooltipCell = (props: FixmeType) => {
    const { value } = props;

    const [isTooltipEnabled, setIsTooltipEnabled] = React.useState<boolean>(false);
    const textContainerRef = React.useRef<HTMLDivElement>(null);

    const updateIsTooltipEnabled = () => {
        if (textContainerRef?.current?.firstChild) {
            // @ts-ignore FIXME: strict migration - 'scrollWidth'/'clientWidth' do not exist on type 'ChildNode' — runtime guaranteed to be an HTMLElement here
            const { scrollWidth, clientWidth } = textContainerRef.current?.firstChild;
            const isOverFlown = scrollWidth > clientWidth;
            setIsTooltipEnabled(isOverFlown);
        }
    };

    React.useEffect(() => {
        updateIsTooltipEnabled();
        const debounceUpdateIsTooltipEnabled = _.debounce(updateIsTooltipEnabled, 5);
        window.addEventListener("swColumnsResize", debounceUpdateIsTooltipEnabled);
        return () => window.removeEventListener("swColumnsResize", debounceUpdateIsTooltipEnabled);
    }, []);

    return (
        <FlexRow ref={textContainerRef}>
            <PlainTooltip
                text={value}
                cssClassContent="plainTooltip-content-without-space"
                enabled={isTooltipEnabled}
            >
                <TextToPresent>{value}</TextToPresent>
            </PlainTooltip>
        </FlexRow>
    );
};
